module.exports = __webpack_public_path__ + "img/max10.65a33d28.png";